import type { VitalsInput } from './types';

/**
 * Client mirror of the API's advisory adult limits (ommri-care-api
 * vital-flags.ts) so values are "flagged as they are typed". The API's flags
 * are the ones shown after saving. Limits await clinic sign-off.
 */
export function liveFlags(v: VitalsInput): string[] {
  const f: string[] = [];
  const hi = (x: number | undefined, h: number, name: string) =>
    x !== undefined && x >= h && f.push(`${name} high`);
  const lo = (x: number | undefined, l: number, name: string) =>
    x !== undefined && x < l && f.push(`${name} low`);
  if (!hi(v.bpSystolic, 140, 'Systolic BP'))
    lo(v.bpSystolic, 90, 'Systolic BP');
  if (!hi(v.bpDiastolic, 90, 'Diastolic BP'))
    lo(v.bpDiastolic, 60, 'Diastolic BP');
  if (!hi(v.pulse, 100, 'Pulse')) lo(v.pulse, 50, 'Pulse');
  if (!hi(v.temperatureC, 37.5, 'Temperature'))
    lo(v.temperatureC, 35, 'Temperature');
  lo(v.spo2, 95, 'SpO2');
  hi(v.pain, 7, 'Pain');
  const g = v.glucoseContext === 'fasting' ? 7.0 : 11.1;
  if (!hi(v.glucoseMmol, g, 'Glucose')) lo(v.glucoseMmol, 3.9, 'Glucose');
  return f;
}

export function bmi(weightKg?: number, heightCm?: number): number | null {
  if (!weightKg || !heightCm) return null;
  const m = heightCm / 100;
  return Math.round((weightKg / (m * m)) * 10) / 10;
}
